import { formatPointLabel } from "components/widgets/chart/base/utils";
import { getLeafValue, getVariationGetter, hasTotalPercentage, isAmount, isVariation } from "hooks/widget-data/datapoints-api/helper";
import { language } from "language/default";
import { ChartSelectValueFormatKind, DisplayValueType } from "store/current-dashboard/types";
const getMesureCurrency = (value) => (isAmount(value) ? value.currency : undefined);
const formatValue = (value, format, currency) => formatPointLabel(value, format, "", { currency, minimumFractionDigits: 2 });
const labels = language.en.chart.tooltip;
export const createAmountTooltipLine = (measure, config) => {
    if (!isAmount(measure?.VALUE)) {
        throw Error("Measure is not amount.");
    }
    if (!(config && config.label && config.format)) {
        throw Error("Measure configuaration is invalid.");
    }
    const { format, label } = config;
    // Get amount and currency
    const amount = getLeafValue(measure?.VALUE);
    const currency = getMesureCurrency(measure?.VALUE);
    const formatedValue = formatValue(amount, format, currency);
    const measureTooltipLine = {
        label,
        value: formatedValue
    };
    return measureTooltipLine;
};
export const createValueTooltipLine = (measure, config) => {
    const { format, label } = config;
    const amount = getLeafValue(measure?.VALUE);
    const formatedValue = formatValue(amount, format, undefined);
    const measureTooltipLine = {
        label,
        value: formatedValue
    };
    return measureTooltipLine;
};
export const createVariationTooltipLines = (measure, config) => {
    if (!isVariation(measure?.VALUE)) {
        throw Error("Measure is not variation.");
    }
    if (!(config && config.displayType)) {
        throw Error("Measure configuaration is invalid.");
    }
    const variation = measure?.VALUE;
    const currency = getMesureCurrency(variation.currentValue);
    const variationChangeFormat = config.displayType === DisplayValueType.Percent ? ChartSelectValueFormatKind.percent : config.format;
    const amounts = {
        change: getLeafValue(variation, getVariationGetter(config.displayType)),
        current: getLeafValue(variation.currentValue),
        previous: getLeafValue(variation.previousValue)
    };
    const formated = {
        change: formatValue(amounts.change, variationChangeFormat, currency),
        current: formatValue(amounts.current, config.format, currency),
        previous: formatValue(amounts.previous, config.format, currency)
    };
    return [
        { label: "Current Value", value: formated.current },
        { label: "Previous Value", value: formated.previous },
        { label: "Variation", value: formated.change }
    ];
};
const createTotalPercentageTooltipLine = (measure, preformatted) => {
    const formatedValue = preformatted ? measure?.toString() || "" : formatValue(measure, ChartSelectValueFormatKind.percent);
    return { label: labels.percentageOfTotal, value: formatedValue };
};
const createTooltipLinesFromPreformattedValue = (value, label) => {
    if (isVariation(value)) {
        const variation = value;
        return [
            { label: "Current Value", value: variation.currentValue },
            { label: "Previous Value", value: variation.previousValue },
            { label: "Variation", value: variation.change }
        ];
    }
    return [{ label, value: value }];
};
export const createMesureTooltipLines = (measure, config) => {
    const tooltipLines = [];
    if (config.formattedFieldName && measure?.[config.formattedFieldName]) {
        tooltipLines.push(...createTooltipLinesFromPreformattedValue(measure[config.formattedFieldName], config.label));
    }
    else if (isVariation(measure.VALUE)) {
        const variationTooltipLines = createVariationTooltipLines(measure, config);
        tooltipLines.push(...variationTooltipLines);
    }
    else if (isAmount(measure.VALUE)) {
        const amountTooltipLine = createAmountTooltipLine(measure, config);
        tooltipLines.push(amountTooltipLine);
    }
    else if (measure.VALUE) {
        const valueTooltipLine = createValueTooltipLine(measure, config);
        tooltipLines.push(valueTooltipLine);
    }
    if (config.totalPercentName && measure?.[config.totalPercentName]) {
        tooltipLines.push(createTotalPercentageTooltipLine(measure?.[config.totalPercentName], true));
    }
    else if (hasTotalPercentage(measure)) {
        tooltipLines.push(createTotalPercentageTooltipLine(measure.TotalPercentage));
    }
    return tooltipLines;
};
